import { createStore } from 'redux'
import reducer from 'reducers'

export default createStore(reducer)



// WEBPACK FOOTER //
// ./src/config/store.js